/**
 * The confirm that stands between "AI Suggest" and a draft that already has
 * line items.
 *
 * Both editors REPLACE the line item array outright when the draft arrives —
 * deliberately. Merging AI lines into manual ones was considered and rejected:
 * the AI prompt is instructed never to skip a service, so a merge would put a
 * second service line beside the hand's own and the ticket would bill it
 * twice. Replacement is the honest operation; what was missing was asking
 * first and saying how much goes.
 *
 * With no existing lines there is nothing to lose and no dialog — the normal
 * path stays one tap.
 */
export interface AiReplaceCopy {
  title: string;
  body: string;
  confirmLabel: string;
}

/** Null when there is nothing to confirm. */
export function describeAiReplace(existingLineCount: number): AiReplaceCopy | null {
  if (!Number.isFinite(existingLineCount) || existingLineCount <= 0) return null;
  const n = existingLineCount;
  const noun = n === 1 ? 'line item' : 'line items';
  return {
    title: 'Replace the line items on this ticket?',
    body:
      `AI Suggest builds a fresh set of line items from the job and its rate sheets, ` +
      `and replaces everything on the ticket now. The ${n} ${noun} you have will be removed from this draft. ` +
      `Cancel keeps them exactly as they are.`,
    confirmLabel: `Replace ${n} ${noun}`,
  };
}
